import React from 'react';
import styles from '@base/features/user/styles/rating.module.scss';
import { ReactComponent as Info } from '@ui-kit/icons/info.svg';
import Tooltip from '@ui-kit/components/tooltip';
import { t } from '@base/utils/helpers';

const RATINGS = [
  {
    value: 900,
    color: 'var(--rating-blue)',
  },
  {
    value: 1250,
    color: 'var(--rating-green)',
  },
  {
    value: 1600,
    color: 'var(--rating-yellow)',
  },
  {
    value: 1900,
    color: 'var(--rating-orange)',
  },
  {
    value: Infinity,
    color: 'var(--rating-red)',
  },
];

export default function Rating(props: { children: number }) {
  return (
    <div className={styles.rating}>
      <span style={{ backgroundColor: getRatingColor(props.children) }}>
        {props.children}
      </span>
      <Tooltip overlay={<Overlay />} placement="bottom">
        <Info />
      </Tooltip>
    </div>
  );
}

export function getRatingColor(rating: number): string {
  for (const r of RATINGS) {
    if (rating < r.value) {
      return r.color;
    }
  }
  return 'var(--rating-red)';
}

function Overlay() {
  return (
    <div className={styles.overlay}>
      <h1>{t('rating')}</h1>
      {RATINGS.map((rating) => (
        <div className={styles.ratingRow}>
          <div
            className={styles.circle}
            style={{ backgroundColor: rating.color }}
          />
          {rating.value === Infinity ? ' >= ' : ' < '}
          {rating.value < Infinity ? rating.value : '1900'}
        </div>
      ))}
    </div>
  );
}
